<template>
  <div class="navbar-container">
    <nav class="navbar navbar-expand-lg navbar-light bg-osrs">
      <a class="navbar-brand" href="#">OSRS Genie</a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
              aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" @click="toggleNav">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link to="/" class="nav-link">Home</router-link>
          </li>

          <li class="nav-item">
            <router-link to="/margins/realtime" class="nav-link">Real-Time Margins</router-link>
          </li>
          <b-nav-item-dropdown text="Calculators" right>
            <router-link class="dropdown-item" to="/calc/compare-dps">DPS Calculator</router-link>
            <router-link class="dropdown-item" to="/calc/gear/optimize">Gear Optimizer</router-link>
            <!--            <router-link class="dropdown-item" to="/conversations">Conversations</router-link>-->
          </b-nav-item-dropdown>

        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
  export default {
    name: "Navbar",
    methods: {
      toggleNav() {
        let elem = document.getElementById('navbarNav');
        elem.classList.toggle("collapse");
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue